<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: 0,
      }"
    >
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('form_label_orderStatus') || '状态',
          field: 'orderStatus',
          minWidth: 160,
          align: 'center',
        },
        {
          title: this.$l('form_label_update_time') || '更新时间',
          field: 'v_statusTime',
          minWidth: 170,
          align: 'center',
        },
      ],
    }
  },
  methods: {},
}
</script>
